var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 18C3 9.71573 9.71573 3 18 3C26.2843 3 33 9.71573 33 18C33 26.2843 26.2843 33 18 33C9.71573 33 3 26.2843 3 18ZM30 18C30 11.3726 24.6274 6 18 6C11.3726 6 6 11.3726 6 18C6 24.6274 11.3726 30 18 30C24.6274 30 30 24.6274 30 18ZM18.015 10.5C18.8434 10.5 19.515 11.1716 19.515 12C19.515 12.7693 18.9359 13.4033 18.1899 13.4899L18 13.5C17.1716 13.5 16.5 12.8284 16.5 12C16.5 11.2307 17.0791 10.5967 17.8251 10.5101L18.015 10.5ZM19.4899 17.8251C19.4033 17.0791 18.7693 16.5 18 16.5H16.5L16.3251 16.5101C15.5791 16.5967 15 17.2307 15 18C15 18.8284 15.6716 19.5 16.5 19.5V24L16.5101 24.1749C16.5967 24.9209 17.2307 25.5 18 25.5H19.5L19.6749 25.4899C20.4209 25.4033 21 24.7693 21 24L20.9899 23.8251C20.9099 23.1364 20.3636 22.5901 19.6749 22.5101L19.5 22.5V18L19.4899 17.8251Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.816cbd7369589208e088490ecf269c27.svg";
export { ForwardRef as ReactComponent };